import axios from 'axios';
import calculateRates from './calculateRates';

export type Currency = {
  currencyCodeA: number;
  currencyCodeB: number;
  date: number;
  rateBuy?: number;
  rateSell?: number;
  rateCross?: number;
};

const STORAGE_KEY = 'currency_rates';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const validateRates = (data: unknown): Currency[] => {
  if (!Array.isArray(data)) throw new Error('Currency rates are unavailable.');
  calculateRates(data);
  return data;
};

const getCurrencyRates = async (): Promise<Currency[]> => {
  if (typeof window !== 'undefined') {
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached) as { ts: number; data: Currency[] };
        if (
          parsed &&
          typeof parsed.ts === 'number' &&
          Array.isArray(parsed.data) &&
          Date.now() - parsed.ts >= 0 &&
          Date.now() - parsed.ts < ONE_DAY_MS
        ) {
          return validateRates(parsed.data);
        }
      }
    } catch {
      // Ignore cache read/parse errors and fetch fresh data
    }
  }

  const response = await axios.get<unknown>('https://api.monobank.ua/bank/currency', { timeout: 8000 });
  const data = validateRates(response.data);

  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), data }));
    } catch {
      // Ignore cache write errors
    }
  }

  return data;
};

export default getCurrencyRates;
